import React from 'react'
import ContentLoader from 'react-content-loader'

const SmallLoading = props => (
  <ContentLoader
    width={320}
    height={320}
    viewBox="0 0 320 320"
    backgroundColor={'#333'}
    foregroundColor={'#999'}
    {...props}
  >
    <rect x="0" y="0" rx="5" ry="5" width="320" height="138" />
    <circle cx="280" cy="140" r="25" />
    <rect x="0" y="145" rx="3" ry="3" width="200" height="6" />
    <rect x="0" y="200" rx="3" ry="3" width="320" height="10" />
    <rect x="0" y="220" rx="3" ry="3" width="320" height="10" />
    <rect x="0" y="240" rx="3" ry="3" width="320" height="10" />
    <rect x="0" y="300" rx="3" ry="3" width="100" height="6" />
  </ContentLoader>
)

export default SmallLoading
